const isAdvancedRollingWindow = (
  rw: RelativeDateRange | AdvancedRelativeDateRange,
): rw is AdvancedRelativeDateRange => {
  // @ts-ignore
  return rw.from !== undefined;
};

export default isAdvancedRollingWindow;
